import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { NotificationManager } from 'react-notifications';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    TextField,
    TableRow,
    Dialog,
    Fade,
    MenuItem
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { FacebookShareButton, FacebookIcon, TwitterIcon, EmailIcon, TwitterShareButton, EmailShareButton } from 'react-share';
import { Share, AssignmentOutlined } from '@material-ui/icons';
import instgram from 'assets/images/instagram.png'
import {
    ROLE_CUSTOMER,
    ROLE_PROVIDER,
} from '../../utils/config/constants.js';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
class ReferList extends React.Component {
    state = {
        showShareIcon: false
    }
    componentDidMount() {
        this.props.promoCodeListAction();
    }



    renderPromoImage = index => {
        return (
            <div style={{ width: 200, height: 210 }} key={index}>
                <ContentLoader
                    height={220}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="200" height="210" />
                </ContentLoader>
            </div>
        );
    };
    handleShareIconClose = () => {
        this.setState({
            showShareIcon: false
        })
    }

    copyToClipboard = (e) => {
	    var copyText = document.getElementById("copytext");

	    copyText.select(); 
	    document.execCommand('copy');

	     NotificationManager.success(
                    "Copied to clipboard",
                'Success'
            );

	    this.setState({
		showShareIcon: true
	    })

    };

    render() {

        var message = String(this.props.settings.constants.referral_message);
	var messageCopy = String(this.props.settings.constants.referral_message_copy);
        var referMsg = message.replace("ABCDEF", this.props.userData.referral_code);
	var referMsgCopy = messageCopy.replace("ABCDEF", this.props.userData.referral_code)



        return (
            <div style={{ width: "100%" }}>

{this.props.userData.role == ROLE_PROVIDER &&(   <TableRow>	<textarea
			id="copytext"
            value={'I’m getting jobs and making money with ezPro.Here’s a link and referal code for you to try it too! to get exciting offers! '+this.props.userData.referral_code+' '}
			style={{height: "0px", width: "0px", overflow: "hidden", border: "none", zIndex: "-1000"}}
          	/>

</TableRow> )}
                                     
{this.props.userData.role ==     ROLE_CUSTOMER &&(   <TableRow>	<textarea
			id="copytext"
            value={'Join me on ezPro Home, and get a trustworthy service for Pros in your area to get stuff fixed around to get exciting offers! '+this.props.userData.referral_code+' '}
			style={{height: "0px", width: "0px", overflow: "hidden", border: "none", zIndex: "-1000"}}
          	/>

</TableRow> )}


            {/* <textarea
			id="copytext"
            value={'Join me on ezPro Home, and get a trustworthy service for Pros in your area to get stuff fixed around  '+this.props.userData.referral_code+' to get exciting offers!'}
			style={{height: "0px", width: "0px", overflow: "hidden", border: "none", zIndex: "-1000"}}
          	/> */}


                <div className="d-flex justify-content-center">
                    <button className="custom-button"
                        onClick={
				this.copyToClipboard
            		}>
                        {this.props.userData.referral_code == "" ? "No referral code" : this.props.userData.referral_code}

                        <Share className="ml-2" /> </button>
                    <Dialog
                        id="long-menu"
                        open={this.state.showShareIcon}
                        onClose={this.handleShareIconClose}
                        TransitionComponent={Fade}
                        disableBackdropClick={false}
                        className="align-self-center md-4"
                        aria-labelledby="form-dialog-title"
                    /* PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: 200,
                        },
                    }} */
                    >
                        <MenuItem >
                            <FacebookShareButton
                                url={"https://ezprohome.com"}
                                quote={referMsg}
                            >
                                <FacebookIcon size={32} round />
                            </FacebookShareButton>
                        </MenuItem>
                        <MenuItem >
                            <TwitterShareButton
                                url={"https://ezprohome.com"}
                                quote={referMsg}
                            >
                                <TwitterIcon size={32} round={true} />
                            </TwitterShareButton>
                        </MenuItem>
                        <MenuItem >
                            <a
                             href="https://www.instagram.com/ezprohome/"
                                subject="Refer Earn"
                                quote={referMsg}
                                body={referMsgCopy}
                            >
                                <img src={instgram} size={32} round={true} />
                            </a>
                        </MenuItem>
                    </Dialog>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ promos, settings, auth }) => {
    return {
        promoData: promos.promoData,
        settings: settings,
        userData: auth.userData
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(ReferList);



// WEBPACK FOOTER //
// ./src/components/Customer/ReferList.jsx